import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam, NzUploadFile, NzUploadModule } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-dynamic-upload-image',
  imports: [NzButtonModule, NzIconModule, NzUploadModule],
  templateUrl: './dynamic-upload-image.component.html',
  styleUrl: './dynamic-upload-image.component.scss'
})
export class DynamicUploadImageComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() field!: FormControl;
  fileList: NzUploadFile[] = [];
  constructor(private messageService: NzMessageService) { }
  ngOnInit(): void {
    if(this.field.value){
      this.fileList[0] =
      {
        uid: '-1',
        name: this.field.value.split('/').pop(),
        status: 'done',
        url: this.field.value
      };
    }
  }

  handleChange({ file, fileList }: NzUploadChangeParam): void {
    const status = file.status;
    if (status !== 'uploading') {
      console.log(file, fileList);
    }
    if (status === 'done') {
      this.messageService.success(`${file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      this.messageService.error(`${file.name} file upload failed.`);
    }
  }
}
